import React from 'react';
import {observer} from 'mobx-react';

import {useStores} from '../../../hooks/useStores';

import ActionButton from '../../Buttons/ActionButton';

const ErrorModal = () => {
  const {interfaceStore} = useStores();

  return (
    <div className="error-modal__footer">
      <ActionButton
        btnType="info"
        clickHandler={interfaceStore.closeModal}
      >
        Close
      </ActionButton>
    </div>
  );
};

export default observer(ErrorModal);
